import React, { useEffect, useState } from "react";
import LeftMenuSidebar from "../../unicomponents/LeftMenuSidebar";
import useOrganizationSetting from "../../hooks/useOrganizationSetting";
import { useLocation } from "react-router-dom";
import PhysicalRecord from "./components/PhysicalRecord";
import useVariousRecordInputs from "../../hooks/useVariousRecordInputs";
import useVariousRecordLists from "../../hooks/useVariousRecordLists";
import HealthRecord from "./components/HealthRecord";
import useRegistrationInfo from "../../hooks/useRegistrationInfo";
import { useAuthContext } from "../../context/AuthContext";
import SimpleAlertMessageBlock from "../../unicomponents/SimpleAlertMessageBlock";
import LoadingInside from "../../unicomponents/LoadingInside";
import PrincipalComment from "./components/PrincipalComment";
import DreamAndMuseum from "./miraldureComponents/DreamAndMuseum";
import JubileeDevotion from "./jubileeComponents/JubileeDevotion";
import JubileeHealth from "./jubileeComponents/JubileeHealth";
import JubileeReadingIndex from "./jubileeComponents/JubileeReadingIndex";
import JubileeRelationship from "./jubileeComponents/JubileeRelationship";
import JubileeSelfDirected from "./jubileeComponents/JubileeSelfDirected";
import JubileeSelfMathEvaluation from "./jubileeComponents/JubileeSelfMathEvaluation";
import { useTranslation } from "react-i18next";
import CoommiPep from "./coommiComponents/CoommiPep";
import CoommiMyGrowthReport from "./coommiComponents/CoommiMyGrowthReport";
import HrTeacherComment from "./components/HrTeacherComment";
import OuterTest from "./miraldureComponents/OuterTest";
import VocabTest from "./miraldureComponents/VocabTest";
import YDTC from "./uofnjcsComponents/YDTC";
import PoemRecord from "./gforestComponents/PoemRecord";
import CoommiChristianCurriculum from "./coommiComponents/CoommiChristianCurriculum";

export default function VariousRecords() {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const schoolId = paths[1];
  const pageUrl = paths[3];
  const conditions = {
    schoolid: schoolId,
  };
  const schoolIdPageUrl = {
    schoolid: schoolId,
    page_url: pageUrl,
  };

  const [inputQueryConditions, setInputQueryConditions] = useState({
    schoolid: schoolId,
    record_list_id: "",
    description: "",
  });

  const {
    settingQuery: { isLoading, data: settingData },
  } = useOrganizationSetting(conditions);

  const {
    variousRecordListsQuery: { data: variousRecordListsData },
  } = useVariousRecordLists(schoolIdPageUrl);

  const {
    variousRecordInputsQuery: { data: variousInputsData },
  } = useVariousRecordInputs(inputQueryConditions);

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "",
    menu_id: "",
  });

  const [variousRecordInfo, setVariousRecordInfo] = useState({});

  const {
    hrTeachersQuery: { data: hrTeachersData },
  } = useRegistrationInfo(conditions, {
    registrationInfo: false,
    hrTeachers: true,
  });

  const { hasPermission } = useAuthContext();

  useEffect(() => {
    if (variousRecordListsData) {
      setInputQueryConditions((prev) => ({
        ...prev,
        record_list_id: variousRecordListsData[0].id,
        description: variousRecordListsData[0].description,
      }));
      setActiveMenu({
        menu_name: variousRecordListsData[0].record_name,
        menu_id: variousRecordListsData[0].id,
      });

      setVariousRecordInfo(variousRecordListsData[0]);
    }
  }, [variousRecordListsData]);

  const handleQueryCondition = (item) => {
    if (item?.id) {
      setInputQueryConditions((prev) => ({
        ...prev,
        record_list_id: item.id,
        description: item.description,
      }));
      setVariousRecordInfo(item);
    }
  };

  function renderComponent() {
    const filteredInputData = variousInputsData
      .filter(
        (item) => item.record_list_id === inputQueryConditions.record_list_id
      )
      .sort((a, b) => {
        const orderA = parseInt(a.order, 10);
        const orderB = parseInt(b.order, 10);

        if (isNaN(orderA) && isNaN(orderB)) {
          return 0;
        } else if (isNaN(orderA)) {
          return 1;
        } else if (isNaN(orderB)) {
          return -1;
        } else {
          return orderA - orderB;
        }
      });

    switch (activeMenu.menu_name) {
      case "physicalRecord":
        return (
          <PhysicalRecord
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
          />
        );
      case "healthRecord":
        return (
          <HealthRecord
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
          />
        );
      case "principalComment":
        return (
          <PrincipalComment
            settingData={settingData}
            schoolId={schoolId}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "dreamAndMuseum":
        return (
          <DreamAndMuseum
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeDevotion":
        return (
          <JubileeDevotion
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeHealth":
        return (
          <JubileeHealth
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeReadingIndex":
        return (
          <JubileeReadingIndex
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeRelationship":
        return (
          <JubileeRelationship
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeSelfDirected":
        return (
          <JubileeSelfDirected
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "jubileeSelfMathEvaluation":
        return (
          <JubileeSelfMathEvaluation
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "coommiPep":
        return (
          <CoommiPep
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "coommiMyGrowthReport":
        return (
          <CoommiMyGrowthReport
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );
      case "hrTeacherComment":
        return (
          <HrTeacherComment
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );

      case "vocabTest":
        return (
          <VocabTest
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );

      case "outerTest":
        return (
          <OuterTest
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );

      case "uofnjcsYDTC":
        return (
          <YDTC
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );

      case "gforestPoem":
        return (
          <PoemRecord
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            inputQueryConditions={inputQueryConditions}
            hrTeachersData={hrTeachersData}
            variousRecordInfo={variousRecordInfo}
          />
        );

      case "coommiChristianCurriculum":
        return (
          <CoommiChristianCurriculum
            settingData={settingData}
            schoolId={schoolId}
            variousRecordInfo={variousRecordInfo}
          />
        );

      default:
        return (
          <PhysicalRecord
            settingData={settingData}
            inputData={filteredInputData}
            schoolId={schoolId}
            hrTeachersData={hrTeachersData}
          />
        );
    }
  }

  if (isLoading) {
    return <LoadingInside />;
  }

  if (!hasPermission(null, "can_access")) {
    return (
      <SimpleAlertMessageBlock
        message={t("common.messages.noAccessPermission")}
      />
    );
  }

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={variousRecordListsData}
              extraFunction={handleQueryCondition}
            />
          </div>
          <div className="col-12 col-md-10">
            {variousInputsData && renderComponent()}
          </div>
        </div>
      </div>
    </div>
  );
}
